import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NewQuote from "@/pages/NewQuote";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import KnowledgeBase from "@/pages/KnowledgeBase";
import Suppliers from "@/pages/Suppliers";
import SupplierTracking from "@/pages/SupplierTracking";
import Settings from "@/pages/Settings";
import ExcelFill from "@/pages/ExcelFill";
import PricingStats from "@/pages/PricingStats";
import RealTimeDashboard from "@/pages/RealTimeDashboard";
import PlanAnalysis from "@/pages/PlanAnalysis";
import PriceSearch from "@/pages/PriceSearch";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import "@/App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#1E8B5A] border-t-transparent"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/new-quote" element={
        <ProtectedRoute>
          <NewQuote />
        </ProtectedRoute>
      } />
      <Route path="/projects" element={
        <ProtectedRoute>
          <Projects />
        </ProtectedRoute>
      } />
      <Route path="/projects/:id" element={
        <ProtectedRoute>
          <ProjectDetail />
        </ProtectedRoute>
      } />
      <Route path="/knowledge" element={
        <ProtectedRoute>
          <KnowledgeBase />
        </ProtectedRoute>
      } />
      <Route path="/suppliers" element={
        <ProtectedRoute>
          <Suppliers />
        </ProtectedRoute>
      } />
      <Route path="/supplier-tracking" element={
        <ProtectedRoute>
          <SupplierTracking />
        </ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute>
          <Settings />
        </ProtectedRoute>
      } />
      <Route path="/excel-fill" element={
        <ProtectedRoute>
          <ExcelFill />
        </ProtectedRoute>
      } />
      <Route path="/pricing-stats" element={
        <ProtectedRoute>
          <PricingStats />
        </ProtectedRoute>
      } />
      <Route path="/realtime" element={
        <ProtectedRoute>
          <RealTimeDashboard />
        </ProtectedRoute>
      } />
      <Route path="/plan-analysis" element={
        <ProtectedRoute>
          <PlanAnalysis />
        </ProtectedRoute>
      } />
      <Route path="/price-search" element={
        <ProtectedRoute>
          <PriceSearch />
        </ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
